import { createContext, useState, useContext } from 'react';
import listOfCategories from "../components/screens/epis/products/ListOfCategories";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const isLargeScreen = window.innerWidth > 1200;

    const [drawerOpen, setDrawerOpen] = useState(
        localStorage.getItem("@STW:drawerOpen") === "false"
            ? false
            : isLargeScreen ? true : false
    );

    const [dadosUsuario, setDadosUsuario] = useState(
        localStorage.getItem("@STW:userData")
            ? JSON.parse(localStorage.getItem("@STW:userData"))
            : {}
    );

    const [activeModule, setActiveModule] = useState('epis');

    const [moduloSession, setModuloSession] = useState(null);

    function handleToggleDrawer() {
        setDrawerOpen(!drawerOpen);
        saveMenuStateToLocalStorage("@STW:drawerOpen", !drawerOpen);
    }

    function handleCloseDrawer() {
        setDrawerOpen(false);
        saveMenuStateToLocalStorage("@STW:drawerOpen", false);
    };

    function changeActiveModule(module) {
        setActiveModule(module)
    }

    function updateDadosUsuarioLocalStorage(dados) {
        const userData = JSON.parse(localStorage.getItem("@STW:userData"));
        const newUserData = { ...userData, ...dados };
        localStorage.setItem("@STW:userData", JSON.stringify(newUserData));
        setDadosUsuario(newUserData);
    }

    const saveMenuStateToLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    };

    const getMenuStateFromLocalStorage = (key, defaultValue) => {
        const saved = localStorage.getItem(key);
        return saved ? JSON.parse(saved) : defaultValue;
    };

    function getEmpresaIdSession() {
        return parseInt(localStorage.getItem("@STW:idEmpresaSelected")) || null;
    }

    function setEmpresaIdSession(empresaId) {
        localStorage.setItem("@STW:idEmpresaSelected", empresaId);
    }

    function setEquipamentoIdSession(equipamentoId) {
        localStorage.setItem("@STW:idEquipamentoSelected", equipamentoId);
    }

    function getEquipamentoIdSession() {
        return parseInt(localStorage.getItem("@STW:idEquipamentoSelected")) || null;
    }

    async function signOut() {
        setDadosUsuario({});
        localStorage.clear();
        localStorage.removeItem("@STW:userData");
        window.location = '/';
    }

    function setModuloSessionData(idSessao, idEmpresa, expirationMinutes = 5) {
        const expiration = new Date();
        expiration.setMinutes(expiration.getMinutes() + expirationMinutes);

        const sessionData = {
            idSessao,
            idEmpresa: idEmpresa,
            expiration: expiration.toISOString(),
        };

        setModuloSession(sessionData);
        localStorage.setItem("@STW:userData:session", JSON.stringify(sessionData));
    }

    function getModuloSessionData() {
        const session = localStorage.getItem("@STW:userData:session");

        if (!session) return { expired: true };

        const parsed = JSON.parse(session);

        if (new Date(parsed.expiration) < new Date()) {
            localStorage.removeItem("@STW:userData:session");
            return { expired: true };
        }

        return {
            idSessao: parsed.idSessao,
            idEmpresa: parsed.idEmpresa,
            expires_at: parsed.expiration,
            expired: false
        };
    }

    function markSessionAsExpired() {
        const session = localStorage.getItem("@STW:userData:session");

        if (session) {
            localStorage.removeItem("@STW:userData:session");
        }
    }


    return (
        <AppContext.Provider value={{
            drawerOpen,
            handleToggleDrawer,
            handleCloseDrawer,
            activeModule,
            changeActiveModule,
            token: dadosUsuario.token || null,
            dadosUsuario,
            setDadosUsuario,
            signOut,
            updateDadosUsuarioLocalStorage,
            saveMenuStateToLocalStorage,
            getMenuStateFromLocalStorage,
            getEmpresaIdSession,
            setEmpresaIdSession,
            setEquipamentoIdSession,
            getEquipamentoIdSession,
            getModuloSessionData,
            setModuloSessionData,
            markSessionAsExpired
        }}>
            {children}
        </AppContext.Provider>
    )
}

const useAppContext = () => {
    const context = useContext(AppContext);

    if (!context) {
        throw new Error('useContext must be used within an AppProvider');
    }

    return context;
};

export { AppProvider, useAppContext };